import { CurrencyEnum } from '../../types/enums';
import { ReduxThunk } from '../../types/thunk';

export const setBurnRate = (
  amount: number,
  currency: CurrencyEnum
): ReduxThunk => (dispatch, getState) => {
  dispatch({ type: 'BURN_RATE', amount, currency });
};
